import { observer } from "mobx-react-lite";
import { useField } from "react-final-form";

import { DateTime } from "@bps/date-time";
import { Stack } from "@bps/fluent-ui";
import { LocationsSelectField } from "@modules/practice/screens/shared-components/location/LocationsSelectField.tsx";
import { useStores } from "@stores/hooks/useStores.ts";
import { ChoiceGroupField } from "@ui-components/form/ChoiceGroupField.tsx";
import { DatePickerField } from "@ui-components/form/DatePickerField.tsx";
import { Fieldset } from "@ui-components/form/Fieldset/Fieldset.tsx";
import { TextInputField } from "@ui-components/form/TextInputField.tsx";
import { TimePickerField } from "@ui-components/form/TimePickerField.tsx";

import {
  AwayChoice,
  nameOf
} from "./components/EditUserDayWorkingHours.types.ts";
import { OpeningHoursInfoMessage } from "./components/OpeningHoursInfoMessage.tsx";

export const EditUserDayWorkingHoursFormFields = observer(() => {
  const { core } = useStores();

  const {
    input: { value: awayChoice }
  } = useField(nameOf("awayChoice"));

  return (
    <Fieldset>
      <Stack horizontal tokens={{ childrenGap: 8 }}>
        <DatePickerField
          label="Date"
          name={nameOf("date")}
          minDate={DateTime.jsDateNow()}
        />
        {core.hasMultipleActiveLocations && awayChoice !== AwayChoice.away && (
          <LocationsSelectField
            name={nameOf("orgUnitId")}
            label="Location"
            styles={{ root: { width: 250 } }}
          />
        )}
      </Stack>
      <OpeningHoursInfoMessage />

      <ChoiceGroupField
        name={nameOf("awayChoice")}
        options={[
          {
            key: AwayChoice.present,
            text: "Working from",
            onRenderField: (props, render) => {
              const disabled = !props || !props.checked;
              return (
                <Stack
                  horizontal
                  verticalAlign="center"
                  tokens={{ childrenGap: 8 }}
                  styles={{
                    root: {
                      alignItems: "baseline"
                    }
                  }}
                >
                  {render!(props)}
                  <TimePickerField
                    disabled={disabled}
                    name={nameOf("startTime")}
                    suggestionInterval={30}
                    styles={{
                      subComponentStyles: {
                        textField: {
                          errorMessage: {
                            alignItems: "flex-start"
                          }
                        }
                      }
                    }}
                  />
                  <span> to </span>
                  <TimePickerField
                    disabled={disabled}
                    name={nameOf("endTime")}
                    suggestionInterval={30}
                    styles={{
                      subComponentStyles: {
                        textField: {
                          errorMessage: {
                            alignItems: "flex-start"
                          }
                        }
                      }
                    }}
                  />
                </Stack>
              );
            }
          },
          {
            key: AwayChoice.away,
            text: "Off work"
          }
        ]}
      />

      <TextInputField label="Reason" name={nameOf("reason")} multiline />
    </Fieldset>
  );
});
